import { FrameWallet, assertWindowEthereum } from '@thirdweb-dev/wallets';
import { useConnect } from '@thirdweb-dev/react-core';
import { i as isMobile, C as ConnectingScreen, B as BackButton, M as ModalTitle, a as ModalDescription, g as ButtonLink, I as Img, H as HelperLink } from './headlessConnectUI-0dfa5bbe.browser.esm.js';
import { useState, useRef, useEffect } from 'react';
import { S as Spacer, a as Flex, i as iconSize } from './basic-7307bc92.browser.esm.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import 'detect-browser';
import '@emotion/styled';
import '@emotion/react';
import 'react-qr-code';
import '@radix-ui/react-dialog';
import '@radix-ui/react-icons';
import '@radix-ui/colors';

const FrameFailedConnect = props => {
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(BackButton, {
      onClick: () => props.onBack()
    }), /*#__PURE__*/jsx(Spacer, {
      y: "lg"
    }), /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(ModalTitle, {
        children: "Failed to connect to Frame."
      }), /*#__PURE__*/jsx(Spacer, {
        y: "sm"
      }), /*#__PURE__*/jsx(ModalDescription, {
        children: "Make sure the desktop app is installed and running. You can download Frame from the link below. Make sure to refresh this page once Frame is running."
      })]
    }), /*#__PURE__*/jsx(Spacer, {
      y: "xl"
    }), /*#__PURE__*/jsx(Flex, {
      flexDirection: "column",
      gap: "xs",
      children: /*#__PURE__*/jsxs(ButtonLink, {
        onClick: () => {
          window.open("https://frame.sh", "_blank");
        },
        children: [/*#__PURE__*/jsx(Img, {
          width: iconSize.lg,
          height: iconSize.lg,
          src: props.walletIconURL
        }), /*#__PURE__*/jsx("span", {
          children: "Download Frame"
        })]
      })
    }), /*#__PURE__*/jsx(Spacer, {
      y: "xl"
    }), /*#__PURE__*/jsx(HelperLink, {
      target: "_blank",
      href: props.supportLink,
      children: "Still having troubles connecting?"
    })]
  });
};
const FrameConnectUI = props => {
  const [screen, setScreen] = useState("connecting");
  const connect = useConnect();
  const connectPrompted = useRef(false);
  const {
    walletConfig,
    close,
    goBack
  } = props;
  const downloadLink = "https://frame.sh";
  const supportLink = "https://docs.frame.sh";
  const hideBackButton = props.supportedWallets.length === 1;
  useEffect(() => {
    if (connectPrompted.current) {
      return;
    }

    // if loading
    (async () => {
      // if not mobile we connect
      if (!isMobile()) {
        try {
          connectPrompted.current = true;
          setScreen("connecting");
          await connect(walletConfig);
          close();
        } catch (e) {
          setScreen("connect-failed");
        }
      }

      // on mobile we open the website
      else if (isMobile()) {
        window.open(downloadLink);
      }
    })();
  }, [walletConfig, close, connect, goBack]);
  if (screen === "connecting") {
    return /*#__PURE__*/jsx(ConnectingScreen, {
      hideBackButton: hideBackButton,
      onBack: goBack,
      walletName: walletConfig.meta.name,
      walletIconURL: walletConfig.meta.iconURL,
      supportLink: supportLink
    });
  }
  if (screen === "connect-failed") {
    return /*#__PURE__*/jsx(FrameFailedConnect, {
      onBack: goBack,
      walletIconURL: walletConfig.meta.iconURL,
      supportLink: supportLink
    });
  }
  return null;
};

const frameWallet = () => ({
  id: FrameWallet.id,
  meta: {
    name: "Frame",
    iconURL: "https://frame.nyc3.digitaloceanspaces.com/bundle/home/favicon.8f0e1342.png",
    urls: {
      chrome: "https://chrome.google.com/webstore/detail/frame-companion/ldcoohedfbjoobcadoglnnmmfbdlmmhf",
      firefox: "https://addons.mozilla.org/en-US/firefox/addon/frame-extension"
    }
  },
  create(options) {
    return new FrameWallet(options);
  },
  connectUI: FrameConnectUI,
  isInstalled() {
    const window_ = globalThis?.window;
    if (assertWindowEthereum(window_)) {
      return window_.ethereum?.isFrame || window_.ethereum?.providers?.some(p => p.isFrame) || false;
    }
    return false;
  }
});

export { frameWallet };
